import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as moment from "moment";
import { BehaviorSubject, Observable } from "rxjs";
import * as settings from 'src/app/air/modules/common/lib/air-api-constant';

@Injectable({
    providedIn: "root",
})
export class UploadService {
    private tableRefreshPromise = new BehaviorSubject<any>(null);
    public $tableRefresh = this.tableRefreshPromise.asObservable();
    public getHeaders() {
        let headers = [
            {
                header: "Forwarder Reference No",
                field: "forwarderReferenceNumber",
                editable: true, isDisabled: true,
                isDefault: true,
            },
            {
                header: "At Terminal  Date",
                field: "atTerminalDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "BDP Representative Name",
                field: "forwarderRepresentativeName",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "BDP Service Code",
                field: "bdpServiceCode",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "BOL AWB Number",
                field: "bolAwbNumber",
                editable: false, isDisabled: false,
                isDefault: true,
            },
            {
                header: "Booking No.",
                field: "bookingNumber",
                editable: false, isDisabled: false,
                isDefault: true,
            },
            {
                header: "Master Booking No.",
                field: "masterBookingNumber",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Cargo Type",
                field: "cargoType",
                editable: false, isDisabled: true,
                isDefault: true,
            },
            {
                header: "Carrier ETA Date",
                field: "carrierEta",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Request ETA",
                field: "requestEtaDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Carrier Name",
                field: "carrierName",
                editable: false, isDisabled: true,
                isDefault: true,
            },
            {
                header: "Carrier SCAC Code",
                field: "carrierScacCode",
                editable: false, isDisabled: false,
                isDefault: true,
            },
            {
                header: "Carrier Receive Date",
                field: "internationalCarrierReceiveActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Company Name",
                field: "company",
                editable: false, isDisabled: false,
                isDefault: true,
            },
            {
                header: "Container Number",
                field: "containerNumber",
                editable: false, isDisabled: true,
                isDefault: true,
            },
            {
                header: "Container Empty Delivery  Date",
                field: "containerEmptyDeliveryDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "CO2 Emission",
                field: "carbonEmission",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Customer Service Rep.",
                field: "customerServiceRepresentative",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "File Creation Date",
                field: "fileCreationDate",
                editable: false, isDisabled: true,
                isDefault: true,
            },
            {
                header: "Order Creation Date",
                field: "orderCreationDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Original Booking Date",
                field: "originalBookingDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Departed Place of Receipt Act. Date",
                field: "departedPlaceOfReceiptActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Destination Delivery Act. Date",
                field: "destinationDeliveryActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Destination Delivery Est. Date",
                field: "destinationDeliveryEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Empty Container Pickup  Date",
                field: "emptyContainerPickupDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Goods Available Ship Act. Date",
                field: "goodsAvailableShipActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Goods Available Ship Est. Date",
                field: "goodsAvailableShipEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Latest Delivery Cutoff  Date",
                field: "latestDeliveryCutoffDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            // { "header": "Logistics Status", "field": "logisticStatus", "editable": false, "isDefault": false },
            {
                header: "Method of Transportation Code",
                field: "mot",
                editable: false, isDisabled: false,
                isDefault: true,
            },
            {
                header: "Move Type Description",
                field: "moveTypeDescription",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Original Booking ETA Date",
                field: "originalBookingEta",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Original Booking ETA Delta",
                field: "deltaBooking",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Original Departure ETA Date",
                field: "originalEta",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Original Departure ETA Delta",
                field: "deltaDeparture",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Original Port of Arrival Est.  Date",
                field: "originalPortOfArrivalEstmatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Original Port of Departure Est.  Date",
                field: "originalPortOfDepartureEstmatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Outgate to Customer  Date",
                field: "outgateToCustomerDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Place of Delivery Act. Date",
                field: "placeOfDeliveryActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Place of Delivery Est. Date",
                field: "placeOfDeliveryEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Place of Delivery Name",
                field: "placeOfDeliveryName",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Place of Receipt Act. Date",
                field: "placeOfReceiptActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Place of Receipt Est. Date",
                field: "placeOfReceiptEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Place of Receipt Name",
                field: "placeOfReceiptName",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Port of Arrival Act. Date",
                field: "portOfArrivalActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Port of Arrival Est. Date",
                field: "portOfArrivalEstimationDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Port of Arrival Name",
                field: "portOfArrivalName",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Port of Departure Act. Date",
                field: "portOfDepartureActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Port of Departure Est. Date",
                field: "portOfDepartureEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Port of Departure Name",
                field: "portOfDepartureName",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Predictive ETA Date",
                field: "predictiveEta",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Purchase Order Number",
                field: "purchaseOrderNumber",
                editable: true, isDisabled: true,
                isDefault: true,
            },
            {
                header: "Request ETA Destination  Date",
                field: "requestEtaDestinationDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            { header: "SBU Code", field: "sbu", editable: false, isDisabled: true, isDefault: true },
            {
                header: "Sale Term Code",
                field: "saleTermCode",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "SBU Description",
                field: "sbuDescription",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            // { "header": "Shipment ID", "field": "shipmentId", "editable": true, "isDefault": false, "isDisabled": true },
            {
                header: "Order Number",
                field: "orderNumber",
                isDisabled: true,
                isDefault: true,
            },
            {
                header: "Transship # 1 Arrival Act. Date",
                field: "transshipOneArrivalActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 1 Arrival Est. Date",
                field: "transshipOneArrivalEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 1 Arrival location",
                field: "transshipOneArrivalLocation",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 1 Departure Act. Date",
                field: "transshipOneDepartureActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 1 Departure Est. Date",
                field: "transshipOneDepartureEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 1 Departure Vessel",
                field: "transshipOneDepartureVessel",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 1 Departure Voyage",
                field: "transshipOneDepartureVoyage",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 2 Arrival Act. Date",
                field: "transshipTwoArrivalActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 2 Arrival Est. Date",
                field: "transshipTwoArrivalEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 2 Arrival location",
                field: "transshipTwoArrivalLocation",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 2 Departure Act. Date",
                field: "transshipTwoDepartureActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 2 Departure Est. Date",
                field: "transshipTwoDepartureEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 2 Departure Vessel",
                field: "transshipTwoDepartureVessel",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 2 Departure Voyage",
                field: "transshipTwoDepartureVoyage",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 3 Arrival Act. Date",
                field: "transshipThreeArrivalActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 3 Arrival Est. Date",
                field: "transshipThreeArrivalEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 3 Arrival Location",
                field: "transshipThreeArrivalLocation",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 3 Departure Act. Date",
                field: "transshipThreeDepartureActualDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 3 Departure Est. Date",
                field: "transshipThreeDepartureEstimatedDate",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 3 Departure Vessel",
                field: "transshipThreeDepartureVessel",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship # 3 Departure Voyage",
                field: "transshipThreeDepartureVoyage",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship #1 Dept. Vessel Code",
                field: "transshipOneDepartureVesselCode",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship #2 Dept. Vessel Code",
                field: "transshipTowDepartureVesselCode",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            {
                header: "Transship #3 Dept. Vessel Code",
                field: "transshipThreeDepartureVesselCode",
                editable: false, isDisabled: true,
                isDefault: false,
            },
            // {
            //     header: "Vessel Act. Load  Date",
            //     field: "vesselActualLoadDate",
            //     editable: false, isDisabled: true,
            //     isDefault: false,
            // },
            // {
            //     header: "Vessel Code",
            //     field: "vesselCode",
            //     editable: false, isDisabled: true,
            //     isDefault: false,
            // },
            // {
            //     header: "Vessel Name",
            //     field: "vesselName",
            //     editable: false, isDisabled: true,
            //     isDefault: false,
            // },
            // {
            //     header: "Vessel Unload  Date",
            //     field: "vesselUnloadDate",
            //     editable: false, isDisabled: true,
            //     isDefault: false,
            // },
            // {
            //     header: "Voyage Number",
            //     field: "voyageNumber",
            //     editable: false, isDisabled: true,
            //     isDefault: false,
            // },
            // {
            //     header: "Updated On",
            //     field: "updatedOn",
            //     editable: false,
            //     isDisabled: true,
            //     isDefault: true,
            // },
            {
                header: "Updated By",
                field: "uploadedBy",
                editable: false,
                isDisabled: true,
                isDefault: true,
            },
            {
                header: "Profile",
                field: "profile",
                editable: false,
                isDefault: false,
            },
            {
                header: "Remarks",
                field: "remark",
                editable: false, isDisabled: true,
                isDefault: false,
            },

        ];
       return headers;
    }
    demoDate :Date = new Date;
    constructor(protected http: HttpClient) { }

    public getPreSignedUrl(body: any) {
        let url = ""; //settings.AdminEndPoint.Upload.PRE_SIGNED_URL;
        return this.http.post(url, body);
    }

    public uploadFile(file) {
        let body = new FormData();
        let url = settings.AdminEndPoint.ThirdParty.BUIL_SHIPMENT_UPLOAD;
        body.append("file", file);
        return this.http.post(url, body);
    }
    public refreshTable(data: any = {}) {
        this.tableRefreshPromise.next(data);
    }

    public getUploadHistory() {
        let url = settings.AdminEndPoint.ThirdParty.GET_FILE_UPLOAD_HISTORY;
        return this.http.get(url);
    }

    public getUploadedShipments(body = {}) {
        let url = settings.AdminEndPoint.ThirdParty.VIEW_UPLOADED_SHIPMENT;
        return this.http.post(url, body);
    }

    public saveOrUpdateShipments(body = {}) {
        let url = settings.AdminEndPoint.ThirdParty.SAVE_UPLOAD_DATA;
        return this.http.post(url, body);
    }

    public deleteUploadedShipment(shipmentIds) {
        let body = { "shipmentId": shipmentIds }
        let url = settings.AdminEndPoint.ThirdParty.DELETE_UPLOADED_DATA;
        return this.http.post(url, body);
    }

    public downloadErrorLogFile(fileId: string): Observable<Blob> {
        let url = settings.AdminEndPoint.ThirdParty.DOWNLOAD_ERROR_LOG;
        const params = new HttpParams().set('fileId', fileId);
        const filename = encodeURIComponent('download.csv');
        const headers = new HttpHeaders().set('Accept', 'text/csv').set('Content-Disposition', `attachment;filename=${filename}`);
        return this.http.get(url, { params, headers, responseType: 'blob' });
    }

    public getReleaseNotes(){
        let docType="Release_Notes"
        let queryParams = new HttpParams().set("docType",docType);
        return this.http.get(settings.AirAppRoutes.ReleaseNotes.GET_RELEASE_NOTES, { params: queryParams });
    }

    public getReleaseNotesById(fileRecord:any){
        let body={
            "docType":"Release_Notes",
            "folderName":fileRecord.folderName
        }
        return this.http.post(settings.AirAppRoutes.ReleaseNotes.GET_RELEASE_NOTES_BY_ID, body );
    }


    public uploadReleaseNoteFile(file, folderName, releaseDate) {
        const formData: FormData = new FormData();
        formData.append('file', file);
        formData.append('docType', 'Release_Notes');
        formData.append('folderName', folderName);
        formData.append('releaseDate',releaseDate) ;
        return this.http.post(settings.AirAppRoutes.ReleaseNotes.UPLOAD_RELEASE_NOTES , formData);
    }

   
   
    
}
